import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "SALES_TAX/ADDRESS_INFORMATION_CARD";
const initialState = {
    loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
    allRequiredFieldsTouched: false,
    zipCodeValidationSuccess: false,
    showSavedAddress: true,
    salesTax: 0,
    salexTaxCalculationSuccessfull: false,
    selectedAddress: { label: 'Select an address', value: null },
    addressInformation: {

        Address: {
            value: "",
            errors: {},
            rules: { required: true }
        },

        Country: {
            label: "",
            value: "",
            errors: {},
            rules: { required: true }
        },

        State: {
            label: "",
            value: "",
            errors: {},
            rules: { required: true }
        },

        City: {
            value: "",
            errors: {},
            rules: { required: true }
        },

        ZIP: {
            value: "",
            errors: {},
            rules: { required: true }
        },

        Email: {
            value: "",
            errors: {},
            rules: { required: true, regex: { pattern: /^\S+@\S+\.\S+$/, message: "Please enter a valid email address" } }
        },
    },
}

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setZipCodeValidationSuccess: (state, action) => {
            state.zipCodeValidationSuccess = action.payload;
        },
        setAddressInformation: (state, action) => {

            let addressInformation = { ...state.addressInformation };
            Object.entries(action.payload).map(([key, value]) => {
                addressInformation = {
                    ...state.addressInformation,
                    [key]: {
                        ...state.addressInformation[key],
                        ...value
                    },
                };

                state.addressInformation = addressInformation;
            })

            // if country is updated then set the State to the initial value
            if ('Country' in action.payload && !(action.payload?.ZIP) && !(action.payload?.State)) {
                state.addressInformation.State = { ...state.addressInformation.State, label: "", value: "" };
                state.addressInformation.ZIP.value = "";

                if (action.payload.Country?.value !== "US") {
                    state.zipCodeValidationSuccess = true;
                } else {
                    state.zipCodeValidationSuccess = false;
                }
            }
            
            if ('State' in action.payload && !(action.payload?.ZIP) && state.addressInformation.ZIP.value && state.addressInformation.Country.value == "US") {
                state.addressInformation.ZIP.value = "";
                state.zipCodeValidationSuccess = false;
            }

        },
        resetAddressInformation: (state, action) => {
            state.addressInformation = JSON.parse(JSON.stringify(initialState.addressInformation))
        },
        setAllRequiredFieldsTouched: (state, action) => {
            state.allRequiredFieldsTouched = action.payload;
        },
        setSalesTax: (state, action) => {
            state.salesTax = action.payload;
        },
        setSalexTaxCalculationSuccessfull: (state, action) => {
            state.salexTaxCalculationSuccessfull = action.payload;
        },
        setSelectedAddress: (state, action) => {
            state.selectedAddress = action.payload;
        },
        setShowSavedAddress: (state, action) => {
            state.showSavedAddress = action.payload;
        },
    },
    initialReducerState: JSON.parse(JSON.stringify(initialState))
})

export const { setLoadingState, setSelectedAddress, setZipCodeValidationSuccess, resetAddressInformation, setAddressInformation, setAllRequiredFieldsTouched, setSalesTax, setSalexTaxCalculationSuccessfull, setShowSavedAddress } = actions;